<template>
  <div class="hello">

    <!-- 超时连接   -->
    <div v-if="timeout">
      <img src="../../assets/png/message_empty_fail.png" alt="Revolo device sharing" style="width: auto; height: 50%">
      <div>
        <p style="font-size:40px; line-height: 20px; color: rgb(33, 33, 33); margin-top: 16px; margin-bottom: 8px; text-align: center">Link broken</p>
      </div>
<!--      <div style="margin: 8px 24px">-->
<!--        <div style="font-size: 14px; color: rgb(105, 105, 105); text-align: left; line-height: 5px">-->
<!--          <p>1.Share expired</p>-->
<!--          <p>2.Shared by others</p>-->
<!--        </div>-->
        <div>
          <p style="font-size:24px; color: rgb(33, 33, 33); text-align: center; line-height: 17px">Please inform the sharer to share again</p>
        </div>
<!--      </div>-->
    </div>

    <!--  设备端  -->
    <div v-else-if="mobile">
      <img id="image" src="../../assets/png/share-receive_success.png" alt="Revolo device sharing">
      <div>
        <p style="font-size:24px; margin-top:30px; text-align: center">You received an invitation from Revolo.</p>
      </div>
<!--      <div align="center">-->
<!--        <p style="font-size:18px; width:70%; height:auto; margin-top:30px; margin-bottom:8px">If you already have a Revolo account.</p>-->
<!--        <mt-button type="primary" size="large" style="background-color:#448AFF; border-radius:15px; width:60%; height:auto; font-size:24px;" @click.native="handleClick">accept</mt-button>-->
<!--      </div>-->

<!--      <div align="center">-->
<!--        <p style="display:block; font-size:14px; width:50%; height:auto; margin-top:30px; margin-bottom:8px">If you are new user</p>-->
<!--        <p style="font-size:14px; width:50%; height:auto;">-->
<!--          <a :href="downloadurl">Download APP</a>-->
<!--        </p>-->
<!--      </div>-->

      <div align="center">
        <p style="font-size:18px; width:70%; height:auto; margin-top:30px; margin-bottom:8px">If you already have a Revolo account.</p>
        <mt-button type="primary" size=large style="background-color:#1474A4; font-size:16px; margin-top:48px"
                   @click.native="handleClick">accept</mt-button>
      </div>
      <div align="center">
        <p style="display:block; font-size:14px; width:50%; height:auto; margin-top:30px; margin-bottom:8px">If you are new user</p>
        <mt-button type="primary" size=large
                   style="background-color:#DCE8F0; color:#1474A4; font-size:14px; margin-top:16px"
                   @click.native="handleDownload">Download APP</mt-button>
      </div>
    </div>

    <!--  PC端  -->
    <div v-else>
      <img id="image2" src="../../assets/png/share-receive_success.png" alt="Revolo device sharing" style="width: auto; height: 70%; align-content: center">
      <div>
        <p style="font-size:30px; margin-top:30px; text-align: center">Received invitation of using Revolo smart door lock</p>
      </div>
      <div align="center">
        <p style="font-size:24px; width:70%; height:auto; margin-top:30px; margin-bottom:8px; text-align: center">Please scan the QR code  to continue</p>
        <!--  二维码   -->
        <qriously :value="url" :size="200" />
      </div>
    </div>

    <!--  微信  -->
    <div v-if="weixinEnv" id="weixin-tip">
      <img src="/src/assets/png/live_weixin.png" style="max-width:90%;" alt="">
    </div>

  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'

export default {
  name: 'Share',
  // components: { qrIouSly },
  data () {
    return {
      url: '',
      mobile: 1,
      type: 'ios',
      appurl: '',
      androidAppUrl: '',
      iosAppUrl: '',
      downloadurl: '',
      timeout: 0,
      weixinEnv: 0,
      shareUrl: process.env.BASE_API + '/#/share/'
      // shareUrl: 'http://localhost/#/share/'
    }
  },
  created () {
    try {
      console.log('----------')
      this.url = window.location.href // 当前页面打开URL页面
      console.log('url >> ' + this.url)
      if (!this.url.includes(this.shareUrl)) {
        // 暂时直接显示超时界面
        this.timeout = 1
        return
      }

      const key = this.url.substring(this.shareUrl.length) // 获取key
      // console.log('key >> ' + key)

      this.iosAppUrl = process.env.BASE_API + '/shareKey=' + key // 拼接token , IOS App跳转
      this.androidAppUrl = process.env.BASE_API + '/share/user?shareKey=' + key // 拼接token , Android App跳转
      // https://test.irevolo.com/revolo?shareKey=66a6bd90-8b07-4c95-94fb-6d6156ecdfc5&firstName=666&lockModel=revolo
    } catch (e) {
      // MessageBox.alert(e, "err");
    }

    // console.log('navigate >> ' + navigator.userAgent)

    // 区分类型
    if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
      this.downloadurl = 'https://www.apple.com.cn/' // IOS APP下载地址
      this.appurl = this.iosAppUrl
      this.type = 'ios'
    } else if (navigator.userAgent.match(/android/i)) {
      this.downloadurl = 'https://play.google.com/store/apps' // Android APP下载地址
      this.appurl = this.androidAppUrl
      this.type = 'android'
    } else {
      this.type = 'pc'
      this.mobile = 0
    }
  },

  mounted () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      this.weixinEnv = 1
    }
    window.addEventListener('hashchange', function (e) {
      console.log('hashchange old >> ' + e.oldURL)
      // window.location.href = e.newURL
      window.location.reload()
      console.log('hashchange new >> ' + e.newURL)
    })
  },

  methods: {
    handleClick () {
      window.location.href = this.appurl // windows.location.href="/url" 唤醒app
      // MessageBox.alert(this.appurl, "this.appurl");
    },
    handleDownload () {
      window.location.href = this.downloadurl
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
  color: #42b983;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#image {
  width: 70%;
  height: auto;
}

#weixin-tip {
  position: fixed;
  left:0; top:0;
  background: rgba(0,0,0,0.8);
  filter:alpha(opacity=80);
  width: 100%;
  height: 100%;
  z-index: 10;
}

#weixin-tip p {
  text-align: center;
  margin-top: 1%;
  padding:0 5%;
}

</style>



// WEBPACK FOOTER //
// src/view/share/share.vue